import { Command, HttpMethod } from "~/extensions/api";
export class DeleteAccountCommand extends Command {
    constructor(loginId) {
        super(HttpMethod.Post, "account/admin/delete");
        this.loginId = loginId;
    }
    /** ログインID */
    loginId = "";
}
